<template>
  <div class="cooperation">
    <div class="cooperation-container">
 
  <div class="title">
        <p>Link</p>
        <h2>友情链接</h2>
      </div>
      <el-row :gutter="20" justify="left">
                    <el-col :span="6" :xs="12"><el-link href="http://www.gov.cn/">中国政府网</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://www.most.gov.cn/">中国科技部</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://www.shanghai.gov.cn/">中国上海</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://www.shkjdw.gov.cn/">上海科技党建</el-link></el-col>
         
        <el-col :span="6"  :xs="12"><el-link href="http://www.sgst.cn/">上海研发公共服务平台</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://www.shtic.com/">上海市科技创业中心</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://www.zjsfq.gov.cn/">张江国家自主创新示范区</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://fgw.sh.gov.cn/">上海市发展和改革委员会</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://sheitc.sh.gov.cn/">上海市经济和信息化委员会</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://sww.sh.gov.cn/">上海市商务委员会</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://edu.sh.gov.cn/">上海市教育委员会</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://czj.sh.gov.cn/">上海市财政局</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://sipa.sh.gov.cn/">上海市知识产权局</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://rsj.sh.gov.cn/201712333/index.shtml">上海市人力资源和社会保障局</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://jrj.sh.gov.cn/">上海市地方金融监管局</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://shsts.stcsm.sh.gov.cn/">上海市科技统计</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://cxq.stcsm.sh.gov.cn/">上海市科技创新券</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://kjjr.shtic.com/index.php/Index/index">上海市科技金融信息服务平台</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://www.sstec.org.cn/">上海市科技服务网</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://www.innofund.gov.cn/">科技型中小企业服务</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://www.innocom.gov.cn/">高新技术企业认定工作网</el-link></el-col>
        <el-col :span="6"  :xs="12"><el-link href="http://www.sast.org.cn/">上海科学院</el-link></el-col>
      </el-row>
 
      </div>
      </div>
</template>

<script>
export default {
  name: "Link",
  data() {
    return {
       
    };
  },
   
  methods: {
     
  }
};
</script>

<style lang="scss" scoped>
.cooperation {
  background-color: #f9faff;
  .cooperation-container {
    width: 1000px;
    margin: 0 auto;
    padding: 30px;
    text-align: center;
    .title {
      p {
        color: #f7a527;
        text-transform: uppercase;
        letter-spacing: 2px;
        word-spacing: 10px;
        font-size: 12px;
        line-height: 20px;
      }
      h2 {
        color: #666666;
        letter-spacing: 10px;
        margin-top: 10px;
      }
    }
    
    
  }
}
@media screen and (max-width: 768px) {
  .cooperation {
  .cooperation-container {
    width: 100%;
    padding: 30px 0px;
    .info{
        padding:30px 10px 10px;
        .el-col-offset-1{margin:0;}
    }
  }
}
}
</style>






// WEBPACK FOOTER //
// src/components/technology/link.vue